
import { WidegtHelperService } from "../services/widgethelper.service";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { LogService } from "../logger/loggerProvider/loggerhelper.service";

export abstract class Widget {
    protected logger: LogService;
    protected translateService: TranslateService;

    constructor(logger: LogService, translateService: TranslateService) {
        this.logger = logger;
        this.translateService = translateService;
    }

    currentStyle: any =
    {
    };

    id:any;
    NAME:any;
    Config:any;
    abstract getConfig(): any;
    abstract Draw(data: any): void; //use first time to draw widget from scratch
    abstract Update(data: any): void; //use after draw to update values.

    private isTranslationCandidate(value: String): boolean {
        if (value && !value.toUpperCase)
            return false;
	else if(value)
            return value.toUpperCase() === value;
            
        return false; 
    }

    SetTransaltion() {
        try {
            let transaltionKeys = new Map<string, string>();
            for (let propName in this.currentStyle) {
                if (this.isTranslationCandidate(this.currentStyle[propName])) {
                    transaltionKeys.set(this.currentStyle[propName], propName);
                }
            }
            for (let propName in this) {
                if (this.isTranslationCandidate(propName)) {
                    transaltionKeys.set(propName, propName);
                }
            }
            for (let propName in this.Config) {
                if (this.Config[propName] && this.isTranslationCandidate(this.Config[propName])) {
                    transaltionKeys.set(this.Config[propName], propName);
                }
            }
            if (this.isTranslationCandidate(this.NAME))
            {
                transaltionKeys.set(this.NAME, "NAME");
            }

            let keys = Array.from(transaltionKeys.keys());
            if (keys && keys.length > 0) {
                let translations = this.translateService.instant(keys);
                
                for (let propName in translations) {
                    if (translations[propName] !== "undefined" && translations[propName] !== propName) {
                        let tempKey = transaltionKeys.get(propName);
                        if (typeof this.currentStyle[tempKey] !== "undefined") {
                            this.currentStyle[tempKey] = translations[propName];
                        }
                        else if (typeof this[tempKey] !== "undefined") {
                            this[tempKey] = translations[propName];
                        }
                        else if (typeof this.Config[tempKey] !== "undefined") {
                            this.Config[tempKey] = translations[propName];
                        }
                    }
                }
            }
        }
        catch (error) {
            if(this.logger != null && typeof this.logger != "undefined")
            this.logger.logError("Error while translation :", error);
        }
    }
}
